module.exports = __webpack_public_path__ + "static/media/logo.63220987.svg";